import React, { Component } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux';
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { VisualFilter } from '@yesplz/core-models'
import { LikeButton } from '@yesplz/core-web/ui-kits/buttons'
import './MinimalPreset.scss'
import BugReportIcon from '@yesplz/core-web/assets/svg/fav-item-selected.svg'
import { saveFilterAsPreset, deleteFilterFromPreset } from '@yesplz/core-redux/ducks/filters'

const filterProps = PropTypes.oneOfType([
  PropTypes.number, PropTypes.string
])

class MinimalPreset extends Component {
  static propTypes = {
    id: PropTypes.string.isRequired,
    presetKey: PropTypes.string,
    name: PropTypes.string,
    coretype: filterProps,
    details: filterProps,
    neckline: filterProps,
    pattern: filterProps,
    shoulder: filterProps,
    sleeveLength: filterProps,
    solid: filterProps,
    color: filterProps,
    category: PropTypes.string,
    topLength: filterProps,
    className: filterProps,
    favorite: PropTypes.bool,
    defaultViewBoxSvg: PropTypes.array,
    style: PropTypes.object,
    onClick: PropTypes.func.isRequired,
    onToggleLike: PropTypes.func.isRequired,
    bottoms: PropTypes.number,
    counters: filterProps,
    covers: filterProps,
    shafts: filterProps,
    toes: filterProps,
    ankle: filterProps,
    knee: filterProps,
    rise: filterProps,
    thigh: filterProps,
    adminPreset: PropTypes.bool,
    handleBugReport: PropTypes.func
  }

  static defaultProps = {
    name: 'unknown',
    coretype: 0,
    details: 0,
    neckline: 0,
    pattern: 0,
    shoulder: 0,
    sleeveLength: 0,
    solid: 0,
    topLength: 0,
    color: null,
    favorite: false,
    adminPreset: false,
    handleBugReport () { }
  }

  get bodyPartFilters () {
    const { coretype, neckline, shoulder, sleeveLength, topLength, bottoms, counters, covers, shafts, toes, ankle, knee, rise, thigh } = this.props
    return {
      coretype, neckline, shoulder, sleeve_length: sleeveLength, top_length: topLength, bottoms, counters, covers, shafts, toes, ankle, knee, rise, thigh
    }
  }

  get fabricFilters () {
    const { details, pattern, solid, color } = this.props
    return { details, pattern, solid, color }
  }

  componentDidMount () {
    const { id, category, defaultViewBoxSvg } = this.props
    // initialize body part
    this.bodyPart = new VisualFilter(`#${id}-svg`, {
      defaultState: this.bodyPartFilters,
      badgeMode: true,
      customViewBox: defaultViewBoxSvg || [75, 50, 250, 200],
      category
    })
  }

  get handleClick () {
    const { name, onClick, category } = this.props
    return () => {
      const filters = {
        ...this.bodyPartFilters,
        ...this.fabricFilters
      }
      onClick(filters, name, category)
    }
  }

  get toggleLike() {
    const { presetKey, name, favorite, onToggleLike, preset, deleteFilter } = this.props
    return (e) => {
      e.preventDefault()
      e.stopPropagation()
      if (favorite) {
        deleteFilter(preset, preset.name, preset.key)
      }
      // const preset = {
      //   key: presetKey,
      //   name,
      //   ...this.bodyPartFilters,
      //   ...this.fabricFilters
      // }
      // onToggleLike(preset, !favorite)
    }
  }

  get handleBugReport () {
    const { handleBugReport } = this.props
    return (e) => {
      e.preventDefault()
      e.stopPropagation()

      handleBugReport()
    }
  }

  render () {
    const { id, name, className, favorite, style, adminPreset } = this.props

    return (
      <div id={id} onClick={this.handleClick} className={classNames('MinimalPreset', { [className]: className })} style={style}>
        <div className='MinimalPreset-svg'>
          {!adminPreset && <LikeButton active={favorite} onClick={this.toggleLike} />}
          {adminPreset && (
            <div className='bug-report-icon' onClick={this.handleBugReport}>
              <img src={BugReportIcon} alt='' />
            </div>
          )}
          <svg id={`${id}-svg`} />
        </div>
        <h3 className='MinimalPreset-title'>{name}</h3>
      </div>
    )
  }
}

const MDTP = dispatch => {
  return {
    deleteFilter: (a, b,c) => dispatch(deleteFilterFromPreset(a,b,c))
  }
}

export default compose(connect(null, MDTP))(MinimalPreset)